/**
 * QiblaFooter.jsx
 * ---------------
 * Footer row showing the bearing (from True North) and the distance to
 * the Kaaba, plus the (optional) city label. Numbers are already
 * formatted by the parent in the user's locale.
 *
 * Purely presentational.
 */
import React from 'react';

export const QiblaFooter = ({
  directionLabel,
  distanceLabel,
  formattedBearing,
  formattedDistance,
  cityLabel,
  surfaceColors,
  textColors,
}) => (
  <div
    className="flex flex-col items-center gap-1 py-3 px-4 text-xs md:text-sm"
    style={{
      borderTop: `1px solid ${surfaceColors.border}`,
      color: textColors.secondary,
    }}
  >
    <div className="flex items-center justify-between w-full max-w-md">
      <span>{directionLabel}</span>
      <span
        data-testid="qibla-bearing-value"
        style={{
          color: textColors.primary,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {formattedBearing}°
      </span>
    </div>
    <div className="flex items-center justify-between w-full max-w-md">
      <span>{distanceLabel}</span>
      <span
        data-testid="qibla-distance-value"
        style={{
          color: textColors.primary,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {formattedDistance} <span style={{ color: textColors.secondary }}>km</span>
      </span>
    </div>

    {cityLabel && (
      <div
        className="text-center pt-1"
        style={{ color: textColors.secondary, fontSize: '11px' }}
      >
        {cityLabel}
      </div>
    )}
  </div>
);
